<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_3_' + this.id]">
    <div class="row m-0">
      <div class="col-md-4">
        <div class="leon">
          <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="" />
        </div>
        <div class="ballon">
          <img src="https://cdn.exploreve.fr/content/ballons/ballon_rose.svg" alt="" />
        </div>
        <div class="support_ballon"></div>
        <div class="support_leon"></div>
      </div>
      <div class="col-md-8">
        <div class="cadre">
          <p style="font-weight: 700;">Salut à toi, et bon retour dans la Troposphère !</p>
          <p>
            Comme je te le disais lors de notre dernière rencontre, pour poursuivre nos aventures, il faut qu’on utilise
            des ballons-songes individuels : mon ballon n’est plus assez grand pour transporter tout le monde !
          </p>
          <p>
            Pour ça, cette fois-ci, je vais t’apprendre à piloter ton ballon : comme tout le monde a désormais le sien,
            c’est parfait. On va essayer d’aller explorêver un peu plus loin dans la Troposphère, dans des endroits que
            l’on n'a pas encore visités.
          </p>
          <p style="font-weight: 700;">
            Ce voyage, c’est aussi un bon moment pour profiter du paysage, et peut-être discuter avec d’autres
            Explorêveurs et Explorêveuses…
          </p>
        </div>
        <NextButton class="button" :url="'/immersion03/' + (this.id + 1)" text="Démarrer l’apprentissage" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NextButton from "@/components/NextButton.vue";

export default {
  name: "IM_3_0",
  data: function () {
    return {
      id: 1
    };
  },
  components: {
    NextButton
  }
};
</script>

<style scoped lang="scss">
.button {
  position: relative;
  top: 80vh;
}

p {
  font-size: 20px;
}

.cadre {
  position: absolute;
  top: 5vh;
  margin: 10px;
  background-color: white;
  max-width: 90vh;
  height: auto;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.cadre::after {
  content: "";
  position: absolute;
  left: -40px;
  top: 30%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 40px solid white;
}

.leon {
  position: absolute;
  top: 20vh;
  left: 40%;
  img {
    height: 60vh;
  }
  z-index: 5;
}

.support_leon {
  position: absolute;
  background-color: $light;
  left: 35%;
  top: 70vh;
  height: 15vh;
  width: 30vh;
  -webkit-border-radius: 15vh / 8vh;
  -moz-border-radius: 15vh / 8vh;
  border-radius: 15vh / 8vh;
  z-index: 4;
}

.ballon {
  position: absolute;
  top: -30vh;
  left: -10%;
  img {
    height: 100vh;
  }
  z-index: 3;
}

.support_ballon {
  position: absolute;
  background-color: $light;
  left: 2%;
  top: 62vh;
  height: 15vh;
  width: 30vh;
  -webkit-border-radius: 15vh / 8vh;
  -moz-border-radius: 15vh / 8vh;
  border-radius: 15vh / 8vh;
}

.send {
  bottom: 6%;
  right: 10% !important;
}
</style>
